import axios from 'axios';
import { ConsentHtmlSignDocumentData } from 'src/ts/interfaces/documents/consent-html-sign-document-data';

interface CreateHtmlSignDocumentParams {
  userId: string;
  documentByCountryId: string;
  data: Record<string, string>;
  ipAddress: string;
  userAgent: string;
  geoLocation: object;
  metadata?: object;
  locale: string;
}

export const createHtmlSignDocumentService = async ({ userId, documentByCountryId, data, ipAddress, userAgent, geoLocation, metadata, locale }: CreateHtmlSignDocumentParams) => {
  try {
    const response = await axios.post(`/signdoc/create-pre-html-sign-doc`, { userId, documentByCountryId, data, ipAddress, userAgent, geoLocation, metadata, locale});

    const returnValue = response.data as ConsentHtmlSignDocumentData;
    return returnValue;
  } catch (error: any) {
    console.error('createHtmlSignDocumentService: ', error);
    return 'verifyInvalid';
  }
};